/**
 * Portfolio organization modal.
 */

'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'portfolioOrganizationModal', ( card ) => ({

		modal: false,

		init() {

			// Test to make sure we're on the "/portfolio" page, AND that the hash is not empty.
			if ( '/portfolio/' !== window.location.pathname || '' === window.location.hash ) return;

			// Skip over cards that don't match the hash.
			if ( card !== window.location.hash.replace( '#!', '' ) ) return;

			// Open the modal.
			this.modal = true;
		},

	}) );
});
